import React, { useState, useEffect } from "react";
import Header from "../../componentes/header/header";
import FinalComponent from "../../componentes/EndPage/Final";
import { Helmet } from "react-helmet";
import privacyData from "./privacidade-traducao.json";

function PrivacyPolicy() {
    const [lang, setLang] = useState(localStorage.getItem("siteLanguage") || "pt");
    const roman = ["I","II","III","IV","V","VI","VII","VIII","IX","X"];
    const [isFixed, setIsFixed] = useState(false);
    const handleLanguageChange = (newLang) => {
        setLang(newLang);
        localStorage.setItem("siteLanguage", newLang);
        window.location.reload();
    };

    useEffect(() => {
    const handleScroll = () => {
        if (window.scrollY > 400) { 
        setIsFixed(true);
        } else {
        setIsFixed(false);
        }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0];
        if (!localStorage.getItem("siteLanguage")) {
            localStorage.setItem("siteLanguage", browserLang);
        }
    }, []);

    const data = privacyData[lang] || privacyData["pt"];

    return (
        <>
            <Header handleLanguageChange={handleLanguageChange} />

            <Helmet>
                <title>{data?.nav_title || "Política de Privacidade | Sobrevidas ACS"}</title>
            </Helmet>

            <div className="mx-[15%] mt-[12%] max-[1500px]:mx-[5%] max-[1500px]:mt-[20%] max-[1000px]:mt-[45%] text-center">

                <h1
                    className="inline-block px-6 py-3 text-[30px] font-black text-[#B040B1] rounded-[50px] leading-tight"
                    style={{
                    background: "linear-gradient(to right, rgba(106,13,173,0.35), rgba(255,102,178,0.35))"
                    }}
                >
                    {data?.page_title || "Política de Privacidade | SobreVidas"}
                </h1>

            </div>

            <div className="flex gap-10 mx-[10%] mt-[5%] mb-[8%] max-[900px]:flex-col max-[768px]:mx-[5%]">

            {/* SIDEBAR */}
            <aside
                className={`
                    w-[270px] left-[5%] z-40 max-[1500px]:hidden
                    ${isFixed 
                    ? "fixed top-10" 
                    : "absolute top-[550px]"
                    }
                `}
            >

                <div className="bg-white rounded-2xl p-5 shadow-[0_10px_30px_rgba(106,13,173,0.08)] border border-[#6A0DAD]/10 h-full flex flex-col">

                    {/* HEADER */}
                    <h3 className="text-[#6A0DAD] font-bold text-sm mb-4 tracking-wide">
                    {data?.toc_title}
                    </h3>

                    {/* LISTA */}
                    <div className="flex flex-col gap-1 overflow-y-auto pr-1">

                    {data.sections.map((sec) => (
                        <a
                        key={sec.id}
                        href={`#${sec.id}`}
                        className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-[#f5edff] hover:text-[#4B0082] transition"
                        >

                        <div className="min-w-[26px] h-[26px] flex items-center justify-center rounded-md bg-[#f5edff] text-[#6A0DAD] text-xs font-bold">
                            {sec.number}
                        </div>

                        <span className="truncate">
                            {sec.title}
                        </span>

                        </a>
                    ))}

                    </div>

                </div>
            </aside>

            {/* CONTEÚDO */}
            <main className="flex-1 max-w-[900px] mx-auto flex flex-col gap-8">

                {data.sections.map((sec) => (
                <div
                    key={sec.id}
                    id={sec.id}
                    className="bg-white p-[30px] rounded-2xl shadow-[0_6px_25px_rgba(0,0,0,0.05)] border border-gray-100"
                >

                    <div className="mb-6 p-4 rounded-xl bg-gradient-to-r from-[#6A0DAD]/10 to-[#ff66b2]/10">

                        <div className="flex items-center gap-3">
                            <div className="px-3 py-1 rounded-md bg-[#6A0DAD] text-white text-xs font-bold">
                            {sec.number}
                            </div>

                            <h2 className="text-[24px] font-bold text-[#4B0082]">
                            {sec.title}
                            </h2>
                        </div>

                    </div>

                    {sec.content && sec.content.split("\n\n").map((p, i) => (
                    <p key={i} className="text-gray-700 mb-4 text-justify leading-relaxed">
                        {p}
                    </p>
                    ))}

                    {/* DOWNLOAD PDF */}
                    {sec.id === "download" && (
                    <div className="mt-6 flex flex-col items-center text-center gap-4">

                        {/* BOTÃO */}
                        <a
                        href={sec.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="
                            flex items-center gap-3
                            px-6 py-3 rounded-xl
                            bg-gradient-to-r from-[#6A0DAD] to-[#B040B1]
                            text-white font-semibold
                            shadow-[0_8px_20px_rgba(106,13,173,0.2)]
                            hover:scale-[1.03] hover:shadow-[0_10px_25px_rgba(106,13,173,0.3)]
                            transition
                        "
                        >
                        {sec.download_label}
                        </a>

                    </div>
                    )}
 
                    {/* DEFINITIONS */}
                    {sec.table && (
                    <div className="overflow-x-auto mt-6 border border-[#6A0DAD]/20 rounded-xl shadow-sm">

                        <table className="w-full text-sm border-collapse">

                        <thead className="bg-[#f5edff]">
                            <tr>
                            <th className="text-center p-3 text-[#6A0DAD] font-semibold w-[30%]">
                                {sec.term_label}
                            </th>
                            <th className="text-center p-3 text-[#6A0DAD] font-semibold">
                                {sec.definition_label}
                            </th>
                            </tr>
                        </thead>

                        <tbody>
                            {sec.table.map((r, i) => (
                            <tr
                                key={i}
                                className="border-t hover:bg-[#faf7ff] transition text-left "
                            >
                                <td className="font-semibold p-3 pl-6 text-[#6A0DAD] align-top ">
                                {r.term}
                                </td>
                                <td className="p-3 pl-6 text-gray-700 leading-relaxed ">
                                {r.definition}
                                </td>
                            </tr>
                            ))}
                        </tbody>

                        </table>
                    </div>
                    )}

                    {/* PRINCIPLES */}
                    {sec.principles && (
                    <div className="mt-6 flex flex-col gap-6">

                        {sec.principles.map((p, i) => (
                        <div key={i} className="flex gap-4 items-start">

                            {/* NÚMERO */}
                            <div className="min-w-[28px] h-[28px] flex items-center justify-center rounded-md bg-[#f5edff] text-[#6A0DAD] text-xs font-semibold">
                            {roman[i] || i + 1}
                            </div>

                            {/* TEXTO */}
                            <div>
                            <p className="font-semibold text-[#6A0DAD] text-[16px] text-left">
                                {p.label}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-justify">
                                {p.text}
                            </p>
                            </div>

                        </div>
                        ))}

                    </div>
                    )}

                    {/* CONTROLADOR */}
                    {sec.contact && (
                    <div className="mt-6">

                        <div className="bg-gradient-to-r from-[#6A0DAD]/10 to-[#B040B1]/10 
                                        border border-[#6A0DAD]/10 
                                        rounded-2xl p-5 
                                        shadow-[0_4px_20px_rgba(106,13,173,0.08)]">

                            {/* LISTA */}
                        <div className="divide-y divide-[#6A0DAD]/10 text-sm">

                            {/* ENDEREÇO */}
                            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 p-4">
                                <span className="text-[#B040B1] font-semibold uppercase text-xs min-w-[120px]">
                                {sec.contact.address_label}
                                </span>
                                <span className="text-gray-700 text-left">
                                {sec.contact.address}
                                </span>
                            </div>

                            {/* EMAIL */}
                            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 p-4">
                                <span className="text-[#B040B1] font-semibold uppercase text-xs min-w-[120px]">
                                {sec.contact.email_label}
                                </span>
                                <a
                                href={`mailto:${sec.contact.email}`}
                                className="text-[#6A0DAD] font-medium hover:underline"
                                >
                                {sec.contact.email}
                                </a>
                            </div>

                            {/* TELEFONE */}
                            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 p-4">
                                <span className="text-[#B040B1] font-semibold uppercase text-xs min-w-[120px]">
                                {sec.contact.phone_label}
                                </span>
                                <span className="text-gray-700">
                                {sec.contact.phone}
                                </span>
                            </div>

                            </div>
                        </div>

                    </div>
                    )}

                    {/* OPERADOR */}
                    {sec.operators && (
                    <div className="mt-6 rounded-2xl border border-[#6A0DAD]/20 bg-[#faf7ff] overflow-hidden">

                        <div className="divide-y divide-[#6A0DAD]/10">

                        {sec.operators.map((op, i) => (
                            <div key={i} className="flex items-start gap-4 p-4">

                            {/* NÚMERO */}
                            <div className="min-w-[28px] h-[28px] flex items-center justify-center 
                                            rounded-full bg-[#B040B1]/10 text-[#B040B1] text-xs font-bold">
                                {i + 1}
                            </div>

                            {/* TEXTO */}
                            <p className="text-gray-700 leading-relaxed text-left">
                                {op}
                            </p>

                            </div>
                        ))}

                        </div>

                        {/* NOTA */}
                        {sec.note && (
                        <div className="p-4 border-t border-[#6A0DAD]/10 bg-[#f5edff] text-sm text-gray-700">
                            {sec.note}
                        </div>
                        )}

                    </div>
                    )}

                    {/* ENCARREGADO */}
                    {sec.email && (
                    <div className="mt-6 rounded-2xl border border-[#6A0DAD]/20 bg-[#faf7ff] p-5">

                        <p className="text-gray-700 leading-relaxed">
                        {sec.contact_note}{" "}
                        <a
                            href={`mailto:${sec.email}`}
                            className="text-[#B040B1] font-semibold hover:underline"
                        >
                            {sec.email}
                        </a>{" "}
                        {sec.contact_note2}
                        </p>

                    </div>
                    )}

                    {/* DIREITOS */}
                    {sec.rights && (
                    <div className="mt-6 flex flex-col gap-4">

                        {sec.rights.map((r, i) => (
                        <div
                            key={i}
                            className="flex gap-4 rounded-xl shadow-sm p-4 border border-l-[10px] border-[#6A0DAD]/2 hover:shadow-md transition"
                        >

                            <div className="flex flex-col gap-1 text-left">
                            <p className="font-semibold text-[#6A0DAD]">
                                {r.label}
                            </p>
                            <p className="text-gray-700 leading-relaxed text-sm">
                                {r.text}
                            </p>
                            </div>
                        </div>
                        ))}

                    </div>
                    )}

                    {/* DADOS TRATADOS */}
                    {sec.professionals && sec.patients && (
                    <div className="mt-6 flex flex-col gap-6">

                        {/* PROFISSIONAIS */}
                        <div className="bg-[#faf7ff] rounded-xl p-5 border border-[#6A0DAD]/10">
                        <p className="text-[#6A0DAD] font-semibold text-lg text-left mb-3">
                            {sec.professionals_label}
                        </p>

                        <div className="flex flex-wrap gap-2">
                            {sec.professionals.map((item, i) => (
                            <span
                                key={i}
                                className="px-3 py-1 text-sm rounded-full bg-white border border-[#6A0DAD]/10 text-gray-700 shadow-sm"
                            >
                                {item}
                            </span>
                            ))}
                        </div>
                        </div>

                        {/* PACIENTES */}
                        <div className="bg-[#fff7fb] rounded-xl p-5 border border-[#B040B1]/10">
                        <p className="text-[#B040B1] text-lg text-left font-semibold mb-3">
                            {sec.patients_label}
                        </p>

                        <div className="flex flex-wrap gap-2">
                            {sec.patients.map((item, i) => (
                            <span
                                key={i}
                                className="px-3 py-1 text-sm rounded-full bg-white border border-[#B040B1]/10 text-gray-700 shadow-sm"
                            >
                                {item}
                            </span>
                            ))}
                        </div>
                        </div>

                    </div>
                    )}

                    {/* COMO OS DADOS SÃO COLETADOS */}
                    {sec.rows && (
                    <div className="mt-6 overflow-hidden rounded-2xl border border-[#6A0DAD]/10 shadow-sm text-left">

                        <table className="w-full text-sm">

                        {/* HEADER */}
                        <thead className="bg-gradient-to-r from-[#f5edff] to-[#fff7fb] text-lg">
                            <tr>
                            <th className="text-left p-4 text-[#6A0DAD] font-bold w-[40%]">
                                {sec.col_data}
                            </th>
                            <th className="text-left p-4 text-[#6A0DAD] font-bold">
                                {sec.col_method}
                            </th>
                            </tr>
                        </thead>

                        <tbody>
                            {sec.rows.map((r, i) => (
                            r.is_header ? (

                                /* CATEGORIA (Profissionais / Pacientes) */
                                <tr key={i}>
                                <td
                                    colSpan={2}
                                    className="bg-[#faf7ff] text-[#6A0DAD] font-semibold p-3 border-t text-base"
                                >
                                    {r.category}
                                </td>
                                </tr>

                            ) : (

                                /* LINHAS */
                                <tr
                                key={i}
                                className="border-t hover:bg-[#faf7ff]/60 transition"
                                >
                                <td className="p-3 text-gray-800 align-top">
                                    {r.data}
                                </td>
                                <td className="p-3 text-gray-600 align-top">
                                    {r.method}
                                </td>
                                </tr>

                            )
                            ))}
                        </tbody>

                        </table>
                    </div>
                    )}

                    {/* TABELA DE TRATAMENTO DE DADOS */}
                    {sec.id === "tratamento" && (
                        <div className="mt-6 overflow-x-auto rounded-xl border border-[#6A0DAD]/10 shadow-sm">
                            <table className="w-full text-sm border-collapse">
                            <thead className="bg-[#f5edff]">
                                <tr>
                                <th className="p-3 text-[#6A0DAD] font-semibold text-left w-[30%]">{sec.col_data}</th>
                                <th className="p-3 text-[#6A0DAD] font-semibold text-left w-[40%]">{sec.col_processing}</th>
                                <th className="p-3 text-[#6A0DAD] font-semibold text-left">{sec.col_purpose}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sec.rows.map((r, i) =>
                                r.is_header ? (
                                    <tr key={i}>
                                    <td colSpan={3} className="bg-[#faf7ff] text-[#6A0DAD] font-semibold p-3">
                                        {r.category}
                                    </td>
                                    </tr>
                                ) : (
                                    <tr key={i} className="border-t hover:bg-[#faf7ff] transition">
                                    <td className="p-3 text-gray-700">{r.data}</td>
                                    <td className="p-3 text-gray-600 text-xs leading-relaxed">{r.processing}</td>
                                    <td className="p-3 text-gray-700">{r.purpose}</td>
                                    </tr>
                                )
                                )}
                            </tbody>
                            </table>
                        </div>
                    )}


                    {/* COMPARTILHAMENTO */}
                    {sec.partners && (
                    <div className="mt-6 flex flex-col gap-3">

                        {sec.partners.map((p, i) => (
                        <div
                            key={i}
                            className="flex items-start gap-3 bg-[#faf7ff] border border-[#6A0DAD]/10 rounded-xl p-4 hover:shadow-sm transition"
                        >
                            <div className="w-2 h-2 mt-2 rounded-full bg-[#B040B1]"></div>

                            <p className="text-gray-700 leading-relaxed">
                            {p}
                            </p>
                        </div>
                        ))}

                    </div>
                    )}

                    {/* TRANSFERÊNCIA INTERNACIONAL */}
                    {sec.id === "transferencia" && (
                    <div> </div>
                    )}

                    {/* SEGURANÇA */}
                    {sec.paragraphs && (
                    <div className="mt-6 flex flex-col gap-4 text-left">

                        {sec.paragraphs.map((p, i) => (
                        <div
                            key={i}
                            className="p-2"
                        >
                            <p className="text-gray-700 leading-relaxed text-sm">
                            {p}
                            </p>
                        </div>
                        ))}

                    </div>
                    )}

                    {/* COOKIES */}
                    {sec.cookies && (
                    <div className="mt-6 flex flex-col gap-4">

                        {/* TÍTULO DA TABELA */}
                        <p className="text-[#6A0DAD] font-semibold mt-2 text-left">
                        {sec.table_title}
                        </p>

                        {/* TABELA */}
                        <div className="overflow-hidden rounded-2xl border border-[#6A0DAD]/10 shadow-sm">

                            <table className="w-full text-sm">

                                {/* HEADER */}
                                <thead className="bg-gradient-to-r from-[#f5edff] to-[#fff7fb] text-center">
                                <tr>
                                    <th className="text-left p-4 text-[#6A0DAD] font-semibold w-[35%]">
                                    {sec.col_name}
                                    </th>
                                    <th className="text-left p-4 text-[#6A0DAD] font-semibold">
                                    {sec.col_purpose}
                                    </th>
                                </tr>
                                </thead>

                                {/* BODY */}
                                <tbody>
                                {sec.cookies.map((c, i) => (
                                    <tr
                                    key={i}
                                    className="border-t hover:bg-[#faf7ff]/60 transition text-left"
                                    >
                                    <td className="p-3 font-medium text-[#6A0DAD] text-left">
                                        {c.name}
                                    </td>
                                    <td className="p-3 text-gray-700 text-left">
                                        {c.purpose}
                                    </td>
                                    </tr>
                                ))}
                                </tbody>

                            </table>
                            </div>

                        </div>
                        )}

                </div>
                ))}

            </main>
            </div>

            <FinalComponent />
        </>
    );
}

export default PrivacyPolicy;